import shuffle from "seneca-common/utils/functions/random/shuffle";

import { ConceptContent, ConceptContentSource } from "../types";

export function generateContent(source: ConceptContentSource): ConceptContent {
  return {
    ...source,
    examples: source.randomExampleOrder
      ? shuffle(source.examples)
      : source.examples
  } as unknown as ConceptContent;
}
